import Button from "components/atoms/Button/Button";
import "./TourTooltip.scss";
import { ReactComponent as Cross } from "assets/images/icons/ClearSearch.svg";
import PropTypes from "prop-types";

function TourTooltip({
  continuous,
  index,
  step,
  backProps,
  closeProps,
  primaryProps,
  skipProps,
  tooltipProps,
  size,
  isLastStep,
}) {
  const { content, hideFooter: disableNextButton } = step;
  return (
    <div className="tour-tooltip-container" {...tooltipProps}>
      <div className="tour-tooltip-header">
        <Cross className="ml-auto" {...closeProps} />
      </div>
      <div className="tour-tooltip-content">{content}</div>
      <div className="tour-tooltip-steps">
        {size > 1 &&
          [...Array(size)].map((el, idx) => (
            <div key={idx} className={`tour-tooltip-step ${idx === index ? "tour-tooltip-step-active" : ""}`} />
          ))}
      </div>
      {}
      <div className="tour-tooltip-footer">
        <Button variant="outline-primary" className="rounded-pill mr-auto" {...skipProps}>
          Skip
        </Button>
        {index > 0 && (
          <Button variant="outline-primary" className="rounded-pill " {...backProps}>
            Back
          </Button>
        )}
        {continuous && (
          <Button className="rounded-pill ml-2" disabled={disableNextButton} {...primaryProps}>
            {isLastStep ? "Done" : "Next"}
          </Button>
        )}
      </div>
    </div>
  );
}

TourTooltip.propTypes = {
  continuous: PropTypes.bool.isRequired,
  index: PropTypes.number.isRequired,
  step: PropTypes.instanceOf(Object).isRequired,
  backProps: PropTypes.instanceOf(Object).isRequired,
  closeProps: PropTypes.instanceOf(Object).isRequired,
  primaryProps: PropTypes.instanceOf(Object).isRequired,
  skipProps: PropTypes.instanceOf(Object).isRequired,
  tooltipProps: PropTypes.instanceOf(Object).isRequired,
  size: PropTypes.number.isRequired,
  isLastStep: PropTypes.bool.isRequired,
};

export default TourTooltip;
